import React from 'react'
import cx from 'classnames'

import { Link } from 'components/shared/Link/Link'

import styles from './AuthLink.module.scss'

export const AuthLink = ({
  className = undefined,
  label,
  variant,
  to,
  redirect,
}) => (
  <Link
    className={cx(styles.link, styles.variant, {
      [styles[variant]]: Boolean(variant),
      [className]: Boolean(className),
    })}
    color="primary"
    size="medium"
    {...{ label, variant, to, redirect }}
  />
)
